module.exports = {"431173100":"回龙圩镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/431173.json
// module id = 1916
// module chunks = 0